export default __webpack_public_path__ + "static/media/stagesAlt.2d34450d.svg";